import {
  Colors,
  Flex,
  IconCircleDeleteFilled,
  Typography,
} from '@banhala/ui-kit';
import type { LikeFolder } from 'shared/src/api/likedFolderService/getLikedFolders/types';
import { DRAGGABLE_ITEM_HEIGHT } from './DraggableFolderList';
import { FolderThumbnail } from './FolderThumbnail';

interface FolderOrderEditBasicFolderProps {
  folder: LikeFolder;
}

export const FolderOrderEditBasicFolder = ({
  folder,
}: FolderOrderEditBasicFolderProps) => {
  return (
    <Flex
      horizontal
      height={DRAGGABLE_ITEM_HEIGHT}
      alignItems={'center'}
      backgroundColor={'content_always_white'}
    >
      <Flex.Center width={56}>
        <IconCircleDeleteFilled size={20} fill={Colors.content_disabled} />
      </Flex.Center>
      <FolderThumbnail folder={folder} />
      <Flex
        horizontal
        flex={1}
        alignItems={'center'}
        padding={{ left: 8, right: 16 }}
      >
        <Typography type={'subtitle3'} color={'content_disabled'}>
          기본서랍
        </Typography>
        <Flex padding={{ left: 2 }}>
          <Typography type={'body3'} color={'content_disabled'}>
            {`(${folder.count})`}
          </Typography>
        </Flex>
      </Flex>
    </Flex>
  );
};
